import { Routes, Route } from "react-router-dom";
import CounsellorLayout from "./CounsellorLayout";
import CounsellorDashboard from "../../Pages/Counsellor/CounsellorDashboard";
import CounsellorLead from "../../Pages/Counsellor/CounsellorLead";
import AddCounsellorLead from "../../Pages/Counsellor/SubPages/AddCounsellorLead";
import ErrorPage from "../../ErrorPage";



const CounsellorRoutes = () => {
  return (
    <CounsellorLayout>
      <Routes>
         <Route path="dashboard" element={<CounsellorDashboard />} />
         <Route path="lead-management/view" element={<CounsellorLead />} />
         <Route path="lead-management/add" element={<AddCounsellorLead />} />
<Route path="*" element={<ErrorPage />} />
        {/* Add more super admin pages here */}
      </Routes>
    </CounsellorLayout>
  );
};

export default CounsellorRoutes;
